export const dateTime = new Date().toISOString().replace(/\.\d{3}Z$/, '');